/** Flags efetivas do solicitante (cadastro global ou detalhe da mudança). */
export interface SubtaskRequesterPolicy {
  allow_create: boolean;
  allow_edit: boolean;
  allow_delete: boolean;
}

export const deniedSubtaskRequesterPolicy = (): SubtaskRequesterPolicy => ({
  allow_create: false,
  allow_edit: false,
  allow_delete: false,
});

export function subtaskRequesterPolicyFromFormSchema(
  data:
    | {
        requester_default_allow_create?: boolean;
        requester_default_allow_edit?: boolean;
        requester_default_allow_delete?: boolean;
      }
    | null
    | undefined,
): SubtaskRequesterPolicy {
  return {
    allow_create: Boolean(data?.requester_default_allow_create),
    allow_edit: Boolean(data?.requester_default_allow_edit),
    allow_delete: Boolean(data?.requester_default_allow_delete),
  };
}

export interface CreateSubtaskReviewPermissions {
  canSelect: boolean;
  /** Internas no passo de criação. */
  canEditInternal: boolean;
  /** Chamados no Incidente (anexos e formulário do ticket). */
  canEditExternal: boolean;
  canRemove: boolean;
  canAdd: boolean;
}

export const fullCreateSubtaskReviewPermissions = (): CreateSubtaskReviewPermissions => ({
  canSelect: true,
  canEditInternal: true,
  canEditExternal: true,
  canRemove: true,
  canAdd: true,
});

/** Revisão do pacote na criação da mudança (passo 2). Gestor ou quem não é o solicitante mantém controle total. */
export function computeCreateSubtaskReviewPermissions(opts: {
  isChangeManager: boolean;
  currentUserId?: number;
  requesterId: number;
  changeOwnerId?: number;
  createdBy?: number;
  policy: SubtaskRequesterPolicy;
  /** Pacote na mudança já existente (aba Subtarefas / Adicionar subtarefa). */
  existingChangePackage?: boolean;
}): CreateSubtaskReviewPermissions {
  const {
    isChangeManager,
    currentUserId,
    requesterId,
    changeOwnerId,
    createdBy,
    policy,
    existingChangePackage,
  } = opts;
  const isPrivilegedStakeholder =
    Boolean(currentUserId) &&
    (currentUserId === requesterId ||
      (changeOwnerId != null && currentUserId === changeOwnerId) ||
      (createdBy != null && currentUserId === createdBy));

  if (isChangeManager || isPrivilegedStakeholder) {
    return fullCreateSubtaskReviewPermissions();
  }
  if (!currentUserId || currentUserId !== requesterId) {
    return fullCreateSubtaskReviewPermissions();
  }
  const canCreate = Boolean(policy.allow_create);
  const base: CreateSubtaskReviewPermissions = {
    canSelect: canCreate,
    canEditInternal: false,
    canEditExternal: true,
    canRemove: false,
    canAdd: canCreate,
  };
  if (!existingChangePackage) {
    return base;
  }
  return {
    ...base,
    canEditInternal: Boolean(policy.allow_edit),
    canRemove: Boolean(policy.allow_delete),
  };
}